import { Breadcrumb } from '@components/common/breadcrumb';
import { withTheme } from '@emotion/react';
import React from 'react';
import { getHelpBreadcrumbItems } from './get-help-breadcrumb-from-path';

export interface HelpBreadcrumbProps {
  path: string;
}

const HelpBreadcrumbComponent = ({ path }: HelpBreadcrumbProps) => <Breadcrumb items={getHelpBreadcrumbItems(path)} />;

export const HelpBreadcrumb = withTheme(HelpBreadcrumbComponent);
